var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 12C0 5.37258 5.37258 0 12 0H80.7239C85.8507 0 90.4113 3.25713 92.0747 8.10667L132.549 126.107C135.22 133.896 129.432 142 121.198 142H12C5.37258 142 0 136.627 0 130V12Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }